export default __webpack_public_path__ + "static/media/colors-1024w.d2851bb4.webp";